import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tir-pm-comment-chat" }
const _hoisted_2 = { class: "tir-pm-comment-chat__layout" }
const _hoisted_3 = { class: "tir-pm-comment-chat__spec-container" }
const _hoisted_4 = { class: "tir-pm-comment-chat__scroller-block" }
const _hoisted_5 = { class: "tir-pm-comment-chat__message-tape" }
const _hoisted_6 = { class: "tir-pm-comment-chat__date-create-block" }
const _hoisted_7 = { class: "tir-pm-comment-chat__date-create" }
const _hoisted_8 = {
  key: 0,
  class: "tir-pm-comment-chat__loading"
}
const _hoisted_9 = { class: "tir-pm-comment-chat__controls-wrapper" }
const _hoisted_10 = {
  key: 0,
  class: "tir-pm-comment-chat__quote-message-to-send"
}
const _hoisted_11 = { class: "tir-pm-comment-chat__controls" }
const _hoisted_12 = { class: "tir-pm-comment-chat__inner-input" }
const _hoisted_13 = { class: "tir-pm-comment-chat__inner-buttons" }

import { computed, nextTick, onMounted, onUnmounted, ref, watch } from 'vue';
import { CurrentUser } from 'tir-pm-user-core';
import { TirPmButton, TirPmButtonSizeEnum, TirPmButtonVariantEnum } from 'tir-pm-button';
import {
  TirPmSpinner,
  TirPmFileUploader,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirPmScrollbar,
  TirPmFilePreview,
  IFilePreview,
  FilePreviewVariantEnum,
  FilePreviewAccessEnum,
  TirPmTextEditorFile,
  FileUploaderExtension,
  TirPmTextarea,
} from 'tir-components';
import { PaperClipIcon } from 'tir-style-system/icons/solid';
import { PaperAirplaneIcon, CheckIcon, CrossLinedIcon } from 'tir-style-system/icons/outline';
import { ComponentInstance, delay, useReverseInfiniteScroll } from 'tir-pm-toolkit';

import TirPmCommentChatMessage from './TirPmCommentChatMessage.vue';
import TirPmCommentChatQuoteMessage from './TirPmCommentChatQuoteMessage.vue';
import {
  CommentChatMessageModel,
  CommentFormDataModel,
  CreateCommentFileFolderModel,
  CreateCommentModel,
  GroupCommentModel,
  RemoveFileFromCommentModel,
  UpdateCommentModel,
} from './models';
import { AdapterService } from './adapter/AdapterService';
import { PaginationRequestModel } from '@/models';
import { FileManager } from 'tir-pm-file-upload-manager';
import { onBeforeRouteUpdate } from 'vue-router';
import TirPmCommentDialogModal from './tir-pm-comment-dialog-modal.vue';
import { allExtensions } from 'tir-pm-file-uploader/src/constants';

/**Адаптер */
const pageStep = 15;
/**Смещение элементов пагинации при удалении или добавлении */

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmCommentChat',
  props: {
  /**ID задачи */
  taskId: {
    type: Number,
    required: true,
  },
  /**ID проекта */
  projectId: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const adapter = new AdapterService();

/**Параметры компонента */


/**Кол-во элементов на 1 странице */
let offsetCountItems = 0;

/**Список комментариев */
const comments = ref(new Array<CommentChatMessageModel>());
/**Данные формы */
const formData = ref(new CommentFormDataModel());

/**Основная загрузка */
const isLoadingMain = ref(false);
/**Загрузка при сохранении */
const isLoadingSave = ref(false);
/**Загрузка при инцициализации загрузки файла */
const isLoadingInitUploadFile = ref(false);
/**Сссылка на скролл компонент */
const $scroll = ref<ComponentInstance<typeof TirPmScrollbar>>();
/**Скролл элемент */
const scrollElement = computed(() => $scroll.value?.$scroll);
/**Ссылка на элемент текстареа */
const $textarea = ref<ComponentInstance<typeof TirPmTextarea>>();
/**Ссылка на компонент диалогового окна */
const $dialogModal = ref<ComponentInstance<typeof TirPmCommentDialogModal>>();

const progressUploadFile = computed(() =>
  formData.value.UploadingFile
    ? FileManager.ActiveUploads.value.find(
        (file) => file.FileId === formData.value.UploadingFile.FileId,
      )?.Progress
    : undefined,
);
/**Получить группу комментариев */
const groupedComments = computed((): GroupCommentModel[] => {
  const groups: GroupCommentModel[] = [];
  let currentGroup: GroupCommentModel = null;

  comments.value.forEach((comment) => {
    const dateKey = new Date(comment.DateCreate).toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'long',
    });

    if (!currentGroup || currentGroup.Date !== dateKey) {
      currentGroup = new GroupCommentModel({
        Date: dateKey,
        Comments: [],
      });
      groups.push(currentGroup);
    }

    currentGroup.Comments.push(comment);
  });

  return groups;
});

/**Название прикрепленного файла */
const pinnedFileName = computed(() => {
  if (formData.value.UploadingFile) return formData.value.UploadingFile.Name;
  if (formData.value.RemoteFile && !formData.value.RemoveFileOnSave)
    return formData.value.RemoteFile.Name;
});
const previewFile = computed<IFilePreview>(() => {
  if (formData.value.UploadingFile) {
    return {
      FileId: formData.value.UploadingFile.FileId,
      Url: formData.value.UploadingFile.Url,
      Name: formData.value.UploadingFile.Name,
      Accesses: [FilePreviewAccessEnum.Remove],
      Progress: progressUploadFile.value,
    };
  }
  if (formData.value.RemoteFile) {
    return {
      FileId: formData.value.RemoteFile.Id,
      Url: formData.value.RemoteFile.Url,
      Name: formData.value.RemoteFile.Name,
      Accesses: [FilePreviewAccessEnum.Remove],
    };
  }
});

/**Блокировка кнопки отправки */
const disabledSendButton = computed(
  () =>
    (!formData.value.Message.trim() && !formData.value.UploadingFile) ||
    (progressUploadFile.value !== undefined && progressUploadFile.value !== 100) ||
    isLoadingInitUploadFile.value,
);
/**Режим редактирования */
const isEditMode = computed(() => !!formData.value.EditedComment);
/**Есть несохраненные данные */
const isNoSaved = computed(() => {
  if (formData.value.EditedComment)
    return (
      !!formData.value.UploadingFile ||
      isLoadingInitUploadFile.value ||
      formData.value.Message !== formData.value.EditedComment.Message ||
      formData.value.RemoveFileOnSave
    );

  return !!formData.value.Message || formData.value.UploadingFile || isLoadingInitUploadFile.value;
});

const { isAllLoaded, loadPage } = useReverseInfiniteScroll({
  loadMore: loadCommentPage,
  scrollContainer: () => scrollElement.value,
  topIndent: 100,
});

/**
 * Загрузить страницу комментариев
 * @param page Страница
 */
async function loadCommentPage(page: number) {
  const response = await adapter.getComments(
    props.taskId,
    new PaginationRequestModel({
      Skip: pageStep * (page - 1) + offsetCountItems,
      Take: pageStep,
    }),
  );

  if (response.IsSuccess && response.Value.length) {
    if (page === 1) {
      comments.value = response.Value.reverse();
      onFirstLoad();
    } else {
      comments.value.unshift(...response.Value.reverse());
    }
  }

  return response.IsSuccess && response.Value.length === pageStep;
}

const onFirstLoad = async () => {
  await nextTick();
  scrollToBottom(false);
};

/**Вставка файла */
const insertFile = (event: ClipboardEvent) => {
  const files = event.clipboardData?.files;

  const extension = files[0]?.name.split('.').pop();

  if (!!pinnedFileName.value || !allExtensions.includes(extension as FileUploaderExtension)) return;

  if (files.length) {
    initUploadFile(files[0]);
  }
};
/**Создать папку для загрузки файлов */
const createFileFolder = async (): Promise<boolean> => {
  const response = await adapter.createFolderWithoutEntity(
    new CreateCommentFileFolderModel({
      ProjectId: props.projectId,
      TaskId: props.taskId,
    }),
  );

  if (response.IsSuccess && !!response.Value) formData.value.FileFolderId = response.Value;

  return response.IsSuccess && !!response.Value;
};

/**Инициализировать загрузку файла */
const initUploadFile = async (file: File) => {
  if (isLoadingInitUploadFile.value) return;

  isLoadingInitUploadFile.value = true;
  // Если отствует папка на загрузку
  if (!formData.value.FileFolderId) {
    if (!(await createFileFolder())) {
      isLoadingInitUploadFile.value = false;
      return;
    }
  }

  const response = await FileManager.upload({
    Location: {
      FolderId: formData.value.FileFolderId,
      TaskId: props.taskId,
    },
    Item: {
      File: file,
      CompressSize: 5,
    },
  });

  if (response.IsSuccess) formData.value.UploadingFile = response.Value;
  isLoadingInitUploadFile.value = false;

  return response.IsSuccess;
};

/**
 * Выбрать файл на загрузку
 * @param event
 */
const selectFileToLoad = async (files: File[]) => {
  if (!files.length || isEditMode.value) return;
  await initUploadFile(files[0]);
};
/**Проскролить до комментария */
const scrollToComment = async (commentId: number) => {
  if (!scrollElement.value) return;

  while (!comments.value.some((comment) => comment.Id === commentId)) {
    if (isAllLoaded.value) return;
    await loadPage();
  }

  const commentElement = scrollElement.value.querySelector(
    `.tir-pm-comment-chat-message[data-comment-id='${commentId}']`,
  ) as HTMLElement | undefined;

  if (!commentElement) return;

  // Прокручиваем контейнер так, чтобы комментарий был внизу
  scrollElement.value.scrollTo({
    top:
      commentElement.offsetTop -
      scrollElement.value.clientHeight +
      commentElement.clientHeight +
      50,
    behavior: 'smooth',
  });
};

/**
 * Установить комментарий на который отвечаем
 * @param replyMessage Комментарий
 */
const setReplyComment = async (replyMessage: CommentChatMessageModel) => {
  formData.value = new CommentFormDataModel({
    Message: !formData.value.EditedComment ? formData.value.Message : '',
    ReplyComment: replyMessage,
  });
  await nextTick();
  $textarea.value?.focus();
};

/**
 * Установить редактируемый комментарий
 * @param comment Комментарий
 */
const setEditComment = async (comment: CommentChatMessageModel) => {
  if (formData.value.UploadingFile && progressUploadFile.value !== 100) {
    FileManager.cancel({ FileId: formData.value.UploadingFile.FileId });
  }
  formData.value = new CommentFormDataModel({
    EditedComment: comment,
    Message: comment.Message,
    ReplyComment: comment.ReplyComment,
    FileFolderId: comment.FileFolderId,
    RemoteFile: comment.File,
  });
  await nextTick();
  $textarea.value?.focus();
};

/**Отменить редактирование комментария */
const cancelEditComment = () => {
  formData.value = new CommentFormDataModel();
};

/**Создать комментарий */
const createComment = async (): Promise<boolean> => {
  if (
    !formData.value.Message.trim() &&
    !formData.value.UploadingFile &&
    !formData.value.FileFolderId
  )
    return false;

  const request = new CreateCommentModel({
    TaskId: props.taskId,
    ProjectId: props.projectId,
    Text: formData.value.Message,
    ParentCommentId: formData.value.ReplyComment?.Id,
    FolderId: formData.value.FileFolderId,
  });

  isLoadingSave.value = true;
  const response = await adapter.createCommentTask(request);
  isLoadingSave.value = false;

  if (!response.IsSuccess) {
    showNotificationMessage(response.ErrorMessage ?? 'Произошла ошибка', false);
  }

  formData.value = new CommentFormDataModel();

  return response.IsSuccess;
};

/**Обновить комментарий */
const updateComment = async (): Promise<boolean> => {
  if (
    !formData.value.EditedComment ||
    !formData.value.Message.trim() ||
    !formData.value.FileFolderId
  )
    return false;

  isLoadingSave.value = true;
  if (formData.value.RemoveFileOnSave && formData.value.RemoteFile) {
    await adapter.removeFileFromComment(
      new RemoveFileFromCommentModel({
        CommentId: formData.value.EditedComment.Id,
        FileId: formData.value.RemoteFile.Id,
      }),
    );
  }

  const request = new UpdateCommentModel({
    CommentId: formData.value.EditedComment.Id,
    Text: formData.value.Message,
  });

  const response = await adapter.updateCommentTask(request);
  isLoadingSave.value = false;
  if (!response.IsSuccess) {
    showNotificationMessage(response.ErrorMessage ?? 'Произошла ошибка', false);
  }

  formData.value = new CommentFormDataModel();

  return response.IsSuccess;
};
/**
 * Удалить комментарий
 * @param commentId ID комментария
 */
const removeComment = async (commentId: number): Promise<boolean> => {
  const response = await adapter.deleteCommentTask(commentId);
  if (!response.IsSuccess) {
    showNotificationMessage(response.ErrorMessage ?? 'Произошла ошибка', false);
  }

  return response.IsSuccess;
};

/**
 * Создать / отредактировать комментарий
 */
const upsertComment = async () => {
  if (isEditMode.value) {
    await updateComment();
  } else {
    await createComment();
  }
};

/**
 * Обработчик нажатия клавиши `enter`
 * @param event Событие
 */
const onEnter = (event: KeyboardEvent) => {
  if (event.shiftKey) return;
  event.preventDefault();
  if (disabledSendButton.value) return;
  upsertComment();
};

/**Открепить файл */
const unpinFile = async () => {
  if (formData.value.UploadingFile) {
    if (progressUploadFile.value === 100) {
      if (await createFileFolder()) formData.value.UploadingFile = undefined;
    } else {
      formData.value.UploadingFile = undefined;
      await FileManager.cancel({ FileId: formData.value.UploadingFile.FileId });
    }
  } else {
    if (formData.value.RemoteFile) {
      formData.value.RemoveFileOnSave = true;
    }
  }
};

const showNotificationMessage = (messsage: string, isSuccess: boolean = true) => {
  TirPmNotificationEventBus.emit(
    'add',
    new TirPmNotificationModel({
      title: messsage,
      type: !isSuccess ? 'error' : 'success',
      group: 'general',
      life: 5000,
      colorIcon: 'var(--status-inverted-negative)',
      closable: true,
    }),
  );
};

/**Удалить прикрепленный комментарий */
const deleteReply = () => {
  formData.value.ReplyComment = undefined;
};

function scrollToBottom(animated: boolean = false) {
  if (!scrollElement.value) return;

  scrollElement.value.scrollTo({
    top: scrollElement.value.scrollHeight,
    behavior: animated ? 'smooth' : 'auto',
  });
}

/**
 * Обработчик события создания комментария
 * @param comment Комментарий
 */
const onCreateComment = async (comment: CommentChatMessageModel) => {
  comments.value.push(comment);
  offsetCountItems++;
  await nextTick();
  scrollToBottom(true);
};

/**
 * Обработчик события обновления комментария
 * @param comment Комментарий
 */
const onUpdateComment = (comment: CommentChatMessageModel) => {
  const index = comments.value.findIndex((_comment) => _comment.Id === comment.Id);
  if (index === -1) return;
  comments.value[index] = new CommentChatMessageModel({
    ...comments.value[index],
    Message: comment.Message,
    File: comment.File,
  });
};

/**
 * Обработчик события удаления
 * @param commentId ID комментария
 */
const onRemoveComment = async (commentId: number) => {
  const isExist = comments.value.some((comment) => comment.Id === commentId);
  if (!isExist) return;
  comments.value = comments.value.filter((comment) => comment.Id !== commentId);
  offsetCountItems--;
};

/**
 * Обработчик события завершения загрузки файла
 * @param fileId ID файла
 */
const onCompleteAddFile = (fileId: number) => {
  const comment = comments.value.find((comment) => comment.File && comment.File.Id === fileId);
  if (comment?.File) {
    comment.File.IsProccessing = false;
  }
};

const onLeaveCancelUploadFile = async () => {
  while (isLoadingInitUploadFile.value) {
    await delay(100);
  }
  if (formData.value.UploadingFile && progressUploadFile.value !== 100)
    FileManager.cancel({ FileId: formData.value.UploadingFile.FileId });
};

onBeforeRouteUpdate(async (to, from, next) => {
  if (isNoSaved.value) {
    const isConfirm = await $dialogModal.value.open();
    if (isConfirm) onLeaveCancelUploadFile();

    next(isConfirm);
  } else {
    next(true);
  }
});

onMounted(async () => {
  adapter.OnCreateCommentEvent.on(onCreateComment);
  adapter.OnUpdateCommentEvent.on(onUpdateComment);
  adapter.OnRemoveCommentEvent.on(onRemoveComment);
  adapter.OnCompleteAddFileEvent.on(onCompleteAddFile);
});

onUnmounted(() => {
  adapter.OnCreateCommentEvent.removeListener(onCreateComment);
  adapter.OnUpdateCommentEvent.removeListener(onUpdateComment);
  adapter.OnRemoveCommentEvent.removeListener(onRemoveComment);
  adapter.OnCompleteAddFileEvent.removeListener(onCompleteAddFile);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(TirPmScrollbar), {
            ref_key: "$scroll",
            ref: $scroll,
            style: {"height":"100%","max-height":"100%","width":"100%"},
            "show-on-hover": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedComments.value, (group) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "tir-pm-comment-chat__message-group",
                    key: String(group.Date)
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(group.Date), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.Comments, (comment) => {
                      return (_openBlock(), _createBlock(TirPmCommentChatMessage, {
                        key: comment.Id,
                        commentData: comment,
                        isOwnerMessage: _unref(CurrentUser).Id == comment.Author.Id,
                        onOnReply: setReplyComment,
                        onOnTrash: ($event: any) => (removeComment(comment.Id)),
                        onOnUpdate: setEditComment,
                        onClickReply: _cache[0] || (_cache[0] = ($event: any) => (scrollToComment($event.Id)))
                      }, null, 8, ["commentData", "isOwnerMessage", "onOnTrash"]))
                    }), 128))
                  ]))
                }), 128)),
                (isLoadingMain.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_unref(TirPmSpinner))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (formData.value.ReplyComment || pinnedFileName.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (formData.value.ReplyComment)
                ? (_openBlock(), _createBlock(TirPmCommentChatQuoteMessage, {
                    key: 0,
                    "comment-data": formData.value.ReplyComment,
                    "is-delitable": "",
                    onDeleteReply: deleteReply
                  }, null, 8, ["comment-data"]))
                : _createCommentVNode("", true),
              (previewFile.value)
                ? (_openBlock(), _createBlock(_unref(TirPmFilePreview), {
                    key: 1,
                    file: previewFile.value,
                    variant: _unref(FilePreviewVariantEnum).Inline,
                    "is-disabled-open": "",
                    "skip-remove-confirm": true,
                    onOnClickDelete: unpinFile
                  }, null, 8, ["file", "variant"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(TirPmTextarea), {
              ref_key: "$textarea",
              ref: $textarea,
              label: "Комментарий",
              placeholder: "Текст комментария...",
              modelValue: formData.value.Message,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.Message) = $event)),
              isWithHint: false,
              "is-disabled": isLoadingSave.value,
              "max-height": "10rem",
              onEnter: onEnter,
              onPaste: insertFile
            }, null, 8, ["modelValue", "is-disabled"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            (!isEditMode.value)
              ? (_openBlock(), _createBlock(_unref(TirPmFileUploader), {
                  key: 0,
                  "max-size": 10000 * 1024 * 1024,
                  "is-disabled": !!pinnedFileName.value || isLoadingInitUploadFile.value,
                  onUploadFiles: selectFileToLoad
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TirPmButton), {
                      size: _unref(TirPmButtonSizeEnum).Middle,
                      variant: _unref(TirPmButtonVariantEnum).LinkState,
                      title: "Прикрепить файл",
                      "is-disabled": !!pinnedFileName.value,
                      "is-loading": isLoadingInitUploadFile.value
                    }, {
                      leftSlot: _withCtx(() => [
                        _createVNode(_unref(PaperClipIcon))
                      ]),
                      _: 1
                    }, 8, ["size", "variant", "is-disabled", "is-loading"])
                  ]),
                  _: 1
                }, 8, ["is-disabled"]))
              : (_openBlock(), _createBlock(_unref(TirPmButton), {
                  key: 1,
                  size: _unref(TirPmButtonSizeEnum).Middle,
                  variant: _unref(TirPmButtonVariantEnum).LinkState,
                  title: "Отменить редактирование",
                  onClick: cancelEditComment
                }, {
                  leftSlot: _withCtx(() => [
                    _createVNode(_unref(CrossLinedIcon))
                  ]),
                  _: 1
                }, 8, ["size", "variant"])),
            _createVNode(_unref(TirPmButton), {
              title: "Отправить",
              size: _unref(TirPmButtonSizeEnum).Middle,
              variant: _unref(TirPmButtonVariantEnum).LinkState,
              "is-disabled": disabledSendButton.value,
              "is-loading": isLoadingSave.value,
              onClick: upsertComment
            }, {
              leftSlot: _withCtx(() => [
                (!isEditMode.value)
                  ? (_openBlock(), _createBlock(_unref(PaperAirplaneIcon), { key: 0 }))
                  : _createCommentVNode("", true),
                (isEditMode.value)
                  ? (_openBlock(), _createBlock(_unref(CheckIcon), { key: 1 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["size", "variant", "is-disabled", "is-loading"])
          ])
        ])
      ])
    ]),
    _createVNode(TirPmCommentDialogModal, {
      ref_key: "$dialogModal",
      ref: $dialogModal
    }, null, 512)
  ]))
}
}

})